export default __webpack_public_path__ + "static/media/btn_big_bsc.f7dcdce9.png";